import { AvatarRoot, AvatarImage, AvatarFallback } from '@chakra-ui/react';
import { useEventImageSrc } from '@/hooks/useEventImageSrc';
import { DEFAULT_EVENT_IMAGE } from '@/constants/defaultImages';

type Size = 'sm' | 'md' | 'lg';

interface EventChatAvatarProps {
  /** Raw `chats.image` / `events.image` value (storage path or legacy public URL). */
  stored: string | null | undefined;
  name: string | null | undefined;
  size?: Size;
}

/**
 * Chat list / header avatar: resolves private `event-images` paths via signed URLs.
 * Using raw `chats.image` as `src` breaks after the bucket went private.
 */
export function EventChatAvatar({ stored, name, size = 'md' }: EventChatAvatarProps) {
  const hasImage = Boolean(stored?.trim());
  const src = useEventImageSrc(hasImage ? stored : null);
  const showPhoto = hasImage && src !== DEFAULT_EVENT_IMAGE;

  return (
    <AvatarRoot size={size} bg="blue.100" color="blue.600" fontWeight="bold" flexShrink={0}>
      {showPhoto ? <AvatarImage src={src} alt="" /> : null}
      <AvatarFallback name={name ?? 'E'} />
    </AvatarRoot>
  );
}
